export default {"src":"/_next/static/media/pointer-active.8028c692.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};